import { Component, ComponentChild } from 'preact'
import Panel from '../../control-components/panel'
import { Modal, ModalHeader, ModalBody } from '../modal/'
import AlertComponent from '../../control-components/ui-components/AlertComponent'
import InputGroup from '../../control-components/ui-components/InputGroup'
import DynamicImport from '../utils/DynamicImport'
import Button from '@insided/control/uikit/Button'
const CodeMirror = DynamicImport(async () => await import('../../control-components/codemirror/index'))

interface Props {
  content: string
  title: string
  onChange: (state: {html: string, title: string}) => void
  deleteButtonAction: () => void
  hideDeleteButton?: boolean
}

interface State {
  content: string
  title: string
  showModal: boolean
  isError: boolean
}

const tidyHTML = function(html: string) {
  const d = document.createElement('div');
  d.innerHTML = html;
  return d.innerHTML;
}

export class HTMLWidget extends Component<Props, State> {
  constructor (props: Props) {
    super(props)

    this.state = {
      content: props.content || '',
      showModal: false,
      isError: false,
      title: props.title
    }

    this.handleModalToggle = this.handleModalToggle.bind(this)
    this.handleCloseNotification = this.handleCloseNotification.bind(this)
    this.handleDeleteButton = this.handleDeleteButton.bind(this)
  }

  handleModalToggle () {
    this.setState({
      showModal: !this.state.showModal
    })
  }

  handleCloseNotification () {
    this.setState({
      isError: false
    })
  }

  handleDeleteButton () {
    this.props.deleteButtonAction()
    this.handleModalToggle()
  }

  notifyChanges() {
    this.props.onChange({ html: this.state.content, title: this.state.title })
  }

  render() {
    const {
      content,
      title,
      showModal,
      isError
    } = this.state
    const options = {
      lineNumbers: true,
      mode: 'text/html',
      selectionPointer: true,
      autoRefresh: false,
      autoResize: false
    }

    return (
      <div>
        {isError && (
          <AlertComponent
            messageType='error'
            message=''
            renderHTML
            onClose={this.handleCloseNotification}
          />)}

        <form className='html-widget__form'>
          <InputGroup
            title='Title'
            type='text'
            onChange={(event) => {
              this.setState({ title: event.target.value }, this.notifyChanges)
            }}
            value={title}
          />

          <CodeMirror
            defaultValue={content}
            onChange={(content: string) => {
              this.setState({ content: content }, this.notifyChanges)
            }}
            onBlur={() => {
              const tidyContent = tidyHTML(this.state.content)
              this.setState({ content: tidyContent }, this.notifyChanges)
            }}
            options={options}
          />
        </form>
        {
          !this.props.hideDeleteButton && (
            <Button
              variant='warning'
              title='Delete'
              onClick={this.handleModalToggle}
            />
          )
        }
        <Modal
          isOpen={showModal}
          size='medium'
        >
          <ModalHeader
            title='Delete HTML Widget?'
            onClose={this.handleModalToggle}
          />
          <ModalBody>
            <p>If you delete this widget, it's gone for good.</p>
            <Button
              variant='danger'
              title='Delete'
              onClick={this.handleDeleteButton}
            />
            <Button
              variant='secondary'
              title='Cancel'
              onClick={this.handleModalToggle}
            />
          </ModalBody>
        </Modal>
      </div>
    )
  }
}

interface PanelProps extends Props {
  switcher?: ComponentChild
  dragHandle: ComponentChild
}

const HTMLWidgetPanel = (props: PanelProps) => {
  return (
    <Panel
      collapsible
      customClass='homepage-widget homepage-widget--html'
      title={
        <div className='panel-title-with-switch'>
          <div className='homepage-reorderable-panel-title'>
            {props.dragHandle}
            <span>HTML widget</span>
          </div>
          {props.switcher}
        </div>
    }
    >
      <HTMLWidget {...props} />
    </Panel>
  )
}

export default HTMLWidgetPanel
